import { createFileRoute } from "@tanstack/react-router";
import { ServiceReviewPage } from "@/components/site/ServiceReviewPage";
import { serviceReviewHead } from "@/lib/serviceReviewHead";
export const Route = createFileRoute("/services/structure-and-performance-reset")({
  head: () => serviceReviewHead("structure-and-performance-reset"),
  component: () => <ServiceReviewPage slug="structure-and-performance-reset" />,
});
